import { types } from "../../types/types";

const initialState = {
  binnacle: [],
  //binnacle: {},
};

export const downloadXmlSatStatisticsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.downloadXmlSatStatistics:
      return {
        ...state,
        binnacle: [...action.payload],
      };
    default:
      return state;
  }
};
